export interface ISubscriptionBundleAlertConfiguration {
    id_subscription_bundle_alert_configuration?: number | null
    id_bundle_configuration?: number | null
    id_user: number | null
    trigger_frequency: number
    last_sent_date: string | null
}

export const EmptySubscriptionBundleAlertConfiguration: ISubscriptionBundleAlertConfiguration = {
    id_subscription_bundle_alert_configuration: null,
    id_bundle_configuration: null,
    id_user: null,
    trigger_frequency: -1,
    last_sent_date: null,
}
